<template>
  <div
    class="flex flex-col md:flex-row items-center justify-center w-screen h-max md:h-screen bg-white overflow-hidden"
  >
    <!-- (left / top) panel -->
    <div
      class="w-screen h-max md:w-1/2 md:h-screen flex flex-col items-end border-r border-border-normal bg-background-disabled m-0 overflow-x-hidden"
    >
      <!-- topbar -->
      <div
        class="bg-white border-b border-border-normal w-full flex items-center justify-end "
      >
        <div
          class="max-w-2xl w-full flex items-center p-5 "
        >
          <img
            src="../../assets/images/icon-black.svg"
            alt=""
            class="w-12 ml-2.5"
          >
          <div
            class="flex flex-col ml-2.5"
          >
            <BaseText
              type="label"
              size="md"
              class="text-text-loud"
            >
              Your Free Trial Expired
            </BaseText>
            <BaseText
              type="body"
              size="sm"
              class="text-text-normal "
            >
              {{ getCountdownTime !== '0:00' ? 'Upgrade for 50% off Full Workflow Today' : 'Choose a Subscription to continue using Foreplay' }}
            </BaseText>
            <BaseButton
              v-if="showDevButton"
              class="text-primary-green-100"
              @click="resetTimer"
            >
              Reset Timer
            </BaseButton>
          </div>
          <div
            v-if="getCountdownTime !== '0:00'"
            class="flex-col items-end hidden lg:flex ml-auto"
          >
            <BaseText
              type="label"
              size="md"
              class="text-primary-green-100 flex items-center gap-1"
            >
              <svg
                width="19"
                height="21"
                viewBox="0 0 19 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mb-0.5"
              >
                <path
                  d="M9.0918 12L6.0918 9M6.8418 1.25H11.3418M17.3418 12C17.3418 16.5563 13.6481 20.25 9.0918 20.25C4.53545 20.25 0.841797 16.5563 0.841797 12C0.841797 7.44365 4.53545 3.75 9.0918 3.75C13.6481 3.75 17.3418 7.44365 17.3418 12Z"
                  stroke="#00A879"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ getCountdownTime }}
            </BaseText>
            <BaseText
              type="body"
              size="sm"
              class="text-text-normal"
            >
              50% Off Ending Soon
            </BaseText>
          </div>
        </div>
      </div>
      <div
        class="w-full h-full justify-end flex"
      >
        <div
          class="w-full max-w-2xl flex flex-col items-center h-full"
        >
          <div
            class="w-full px-10"
          >
            <BaseViewToggle
              class="h-12 w-full mt-5"
              :views="['Monthly', 'Annual (Save 10%)']"
              :value="paymentSchedule"
              square
              @input="(value) => {paymentSchedule = value}"
            />
          </div>
          <!-- Plan selection -->
          <div class="w-full px-10 mt-5">
            <!-- <StripeElement /> -->
            <PlanSelection
              v-if="subscriptions.length"
              :subscriptions="subscriptions"
              :selected-subscription="plan"
              :payment-schedule="paymentSchedule"
              :timer-expired="getCountdownTime === '0:00'"
              @planSelected="(newPlan) => { plan = newPlan }"
            />
            <!-- add ons -->
            <ProductSelection
              v-if="subscriptions.length"
              :payment-schedule="paymentSchedule"
              :selected-subscription="plan"
              :spyder-package="spyderPackage"
              :subscriptions="subscriptions"
              :team-emails="teamEmails"
              :team-members="teamMembers"
              @productSelected="(selectedProducts) => { plan = selectedProducts }"
              @updateTeamMembers="(newQuantity) => { teamMembers = newQuantity }"
              @updateSpyders="(newQuantity) => { spyderPackage = newQuantity }"
            />
          </div>
          <!-- Reviews -->
          <div
            class="w-full flex justify-center items-center gap-6 px-12 mt-auto mb-2 select-none pt-5"
          >
            <img
              src="../../assets/images/g2review.png"
              alt=""
              class="w-1/2"
            >
            <img
              src="../../assets/images/chrome-review.png"
              alt=""
              class="w-1/2"
            >
          </div>
        </div>
      </div>
    </div>

    <!-- (right / bottom) panel -->
    <div
      class="w-full h-screen md:w-1/2 md:h-full bg-white md:overflow-y-scoll overflow-x-hidden"
    >
      <!-- Billing Details -->
      <BillingDetails
        v-if="subscriptions.length"
        :subscriptions="subscriptions"
        :products="getProducts"
        :payment-schedule="paymentSchedule"
        :timer-expired="getCountdownTime === '0:00'"
        :plan="plan"
        class="w-full h-max "
        @wipeCountdownTimer="wipeCountdownTimer"
      />

      <!-- Add the renewal date -->
      <div
        class="flex items-center mt-5 mr-auto w-full px-10 pb-9 max-w-2xl h-max"
      >
        <img
          src="../../assets/icons/odometer.svg"
          alt=""
        >
        <BaseText
          type="label"
          size="sm"
          class="text-text-muted ml-3"
          weight="normal"
        >
          Unlimited Usage
        </BaseText>
        <img
          class="ml-auto"
          src="../../assets/icons/support.svg"
          alt=""
        >
        <BaseText
          type="label"
          size="sm"
          class="text-text-muted ml-3"
          weight="normal"
        >
          Expert Support
        </BaseText>
        <img
          class="ml-auto"
          src="../../assets/icons/cancel-card.svg"
          alt=""
        >
        <BaseText
          type="label"
          size="sm"
          class="text-text-muted ml-3"
          weight="normal"
        >
          Cancel Anytime
        </BaseText>
      </div>
      <div
        class="flex items-center justify-center gap-2 mr-auto max-w-2xl w-full px-10 pb-5 h-8"
      >
        <img
          src="../../assets/icons/powered-by-stripe.svg"
          alt=""
          class="h-5 mr-auto"
        >
        <svg
          width="35"
          height="20"
          viewBox="0 0 35 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.15625"
            y="0.219727"
            width="34"
            height="24"
            rx="2"
            fill="#00579F"
          />
          <path
            d="M14.7017 16.3025H12.7793L13.9817 8.64893H15.9041L14.7017 16.3025Z"
            fill="white"
          />
          <path
            d="M21.6711 8.8361C21.2919 8.68124 20.6905 8.51025 19.9468 8.51025C18.0483 8.51025 16.7115 9.55239 16.7033 11.0423C16.6875 12.1416 17.6604 12.7522 18.3881 13.1187C19.1319 13.4933 19.3847 13.7377 19.3847 14.0716C19.3771 14.5843 18.7837 14.8207 18.2302 14.8207C17.4627 14.8207 17.0514 14.6988 16.4265 14.4135L16.1733 14.2913L15.9043 16.0093C16.3552 16.2208 17.1859 16.4084 18.0483 16.4167C20.0655 16.4167 21.3787 15.3906 21.3943 13.8029C21.402 12.9316 20.8882 12.264 19.7806 11.7185C19.1082 11.3683 18.6964 11.1322 18.6964 10.7738C18.7043 10.4481 19.0447 10.1145 19.8037 10.1145C20.4287 10.0981 20.8879 10.2528 21.2358 10.4075L21.4096 10.4888L21.6711 8.8361Z"
            fill="white"
          />
          <path
            d="M24.2263 13.5911C24.3846 13.1514 24.9938 11.4497 24.9938 11.4497C24.9858 11.4661 25.1518 11.0019 25.2467 10.717L25.3811 11.3764C25.3811 11.3764 25.7451 13.2085 25.8242 13.5911C25.5237 13.5911 24.606 13.5911 24.2263 13.5911ZM26.5993 8.64893H25.1123C24.6537 8.64893 24.3053 8.78723 24.1075 9.28395L21.252 16.3024H23.2691C23.2691 16.3024 23.6012 15.3578 23.6726 15.1543C23.8939 15.1543 25.8562 15.1543 26.1408 15.1543C26.196 15.423 26.3702 16.3024 26.3702 16.3024H28.1502L26.5993 8.64893Z"
            fill="white"
          />
          <path
            d="M11.1741 8.64893L9.29136 13.8679L9.08563 12.8095C8.73756 11.5881 7.64593 10.2612 6.42773 9.60135L8.15222 16.2944H10.1851L13.2069 8.64893H11.1741Z"
            fill="white"
          />
          <path
            d="M7.54263 8.64893H4.44961L4.41797 8.80357C6.83071 9.4387 8.42863 10.9697 9.08514 12.8098L8.41275 9.29228C8.30206 8.80346 7.96187 8.66505 7.54263 8.64893Z"
            fill="#FAA61A"
          />
        </svg>
        <img
          src="../../assets/icons/amex-payment-icon.svg"
          class="h-5"
          alt=""
        >
        <svg
          width="34"
          height="20"
          viewBox="0 0 34 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.15625"
            y="0.219727"
            width="33"
            height="24"
            rx="2"
            fill="#232342"
          />
          <path
            d="M14.5352 24.2197L33.1566 18.4697V20.2197C33.1566 22.4289 31.3657 24.2197 29.1566 24.2197H14.5352Z"
            fill="#FD6020"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28.6178 9.83058C29.6423 9.83058 30.2057 10.3141 30.2057 11.2275C30.2569 11.9259 29.7959 12.5169 29.1813 12.6244L30.5643 14.6123H29.4886L28.3105 12.6781H28.208V14.6123H27.3372V9.83058H28.6178ZM28.208 12.0334H28.4641C29.0276 12.0334 29.2837 11.7647 29.2837 11.2812C29.2837 10.8514 29.0276 10.5827 28.4641 10.5827H28.208V12.0334ZM24.315 14.6123H26.7738V13.8064H25.1858V12.5169H26.7225V11.711H25.1858V10.6365H26.7738V9.83057H24.315V14.6123ZM21.7539 13.0542L20.5757 9.83057H19.6537L21.549 14.7197H22.01L23.9052 9.83057H22.9832L21.7539 13.0542ZM11.3555 12.2483C11.3555 13.5915 12.38 14.7197 13.6606 14.7197C14.0704 14.7197 14.4289 14.6123 14.7875 14.4511V13.3766C14.5314 13.6989 14.1728 13.9138 13.763 13.9138C12.9434 13.9138 12.2775 13.2691 12.2775 12.4095V12.302C12.2263 11.4424 12.8922 10.6902 13.7118 10.6365C14.1216 10.6365 14.5314 10.8514 14.7875 11.1737V10.0992C14.4801 9.8843 14.0704 9.83057 13.7118 9.83057C12.38 9.72312 11.3555 10.8514 11.3555 12.2483ZM9.7676 11.6573C9.25537 11.4424 9.1017 11.3349 9.1017 11.0663C9.15292 10.7439 9.40904 10.4753 9.71638 10.529C9.97249 10.529 10.2286 10.6902 10.4335 10.9051L10.8945 10.2604C10.536 9.93803 10.0749 9.72312 9.61393 9.72312C8.8968 9.66939 8.28212 10.2604 8.2309 11.0126V11.0663C8.2309 11.711 8.48702 12.0871 9.30659 12.3557C9.51148 12.4095 9.71638 12.5169 9.92127 12.6244C10.0749 12.7318 10.1774 12.893 10.1774 13.1079C10.1774 13.484 9.87005 13.8064 9.56271 13.8064H9.51148C9.1017 13.8064 8.74313 13.5377 8.58946 13.1616L8.02601 13.7526C8.33335 14.3436 8.94803 14.666 9.56271 14.666C10.3823 14.7197 11.0482 14.075 11.0994 13.2154V13.0542C11.0482 12.4095 10.7921 12.0871 9.7676 11.6573ZM6.79665 14.6123H7.66744V9.83057H6.79665V14.6123ZM2.75 9.83058H4.03058H4.2867C5.51606 9.88431 6.48931 10.9588 6.43808 12.2483C6.43808 12.9467 6.13074 13.5915 5.61851 14.075C5.1575 14.4511 4.59404 14.666 4.03058 14.6123H2.75V9.83058ZM3.87691 13.8064C4.2867 13.8601 4.74771 13.6989 5.05505 13.4303C5.36239 13.1079 5.51606 12.6781 5.51606 12.1946C5.51606 11.7648 5.36239 11.3349 5.05505 11.0126C4.74771 10.7439 4.2867 10.5828 3.87691 10.6365H3.62079V13.8064H3.87691Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.4012 9.71973C16.1206 9.71973 15.0449 10.7943 15.0449 12.1912C15.0449 13.5343 16.0694 14.6626 17.4012 14.7163C18.733 14.7701 19.7575 13.6418 19.8087 12.2449C19.7575 10.848 18.733 9.71973 17.4012 9.71973V9.71973Z"
            fill="#FD6020"
          />
        </svg>
        <svg
          width="35"
          height="20"
          viewBox="0 0 35 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.15625"
            y="0.219727"
            width="34"
            height="24"
            rx="2"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.3993 17.3767C16.2417 18.4049 14.7402 19.0257 13.0995 19.0257C9.43852 19.0257 6.4707 15.9351 6.4707 12.1227C6.4707 8.3103 9.43852 5.21973 13.0995 5.21973C14.7402 5.21973 16.2417 5.84048 17.3993 6.86876C18.5568 5.84048 20.0583 5.21973 21.699 5.21973C25.36 5.21973 28.3278 8.3103 28.3278 12.1227C28.3278 15.9351 25.36 19.0257 21.699 19.0257C20.0583 19.0257 18.5568 18.4049 17.3993 17.3767Z"
            fill="#ED0006"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.3984 17.3767C18.8237 16.1105 19.7275 14.2265 19.7275 12.1227C19.7275 10.0189 18.8237 8.13489 17.3984 6.86876C18.556 5.84048 20.0575 5.21973 21.6982 5.21973C25.3592 5.21973 28.327 8.3103 28.327 12.1227C28.327 15.9351 25.3592 19.0257 21.6982 19.0257C20.0575 19.0257 18.556 18.4049 17.3984 17.3767Z"
            fill="#F9A000"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.3993 6.86877C18.8246 8.13491 19.7283 10.0189 19.7283 12.1227C19.7283 14.2265 18.8246 16.1105 17.3993 17.3766C15.9741 16.1105 15.0703 14.2265 15.0703 12.1227C15.0703 10.0189 15.9741 8.13491 17.3993 6.86877Z"
            fill="#FF5E00"
          />
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import firebase from '../../api/config/FirebaseConfig'
import BillingDetails from '../../components/account/subcriptionv2/BillingDetails.vue'
import PlanSelection from '../../components/account/subcriptionv2/PlanSelection.vue'
import ProductSelection from '../../components/account/subcriptionv2/ProductSelection.vue'
import FirebaseAPI from '@/api/firebase'

export default {
  name: 'PaymentViewV2',
  components: {
    PlanSelection,
    ProductSelection,
    BillingDetails
  },
  data () {
    return {
      paymentSchedule: 'Monthly',
      loadingSubscriptions: false,
      subscriptions: [],
      countdownTime: '10:00',
      countdownInterval: null,
      plan: null,
      products: [],
      teamMembers: 2,
      teamEmails: [],
      spyderPackage: [{
        name: '2 Spyders',
        id: 'no price',
        label: '(Free)',
        value: 0
      }]
    }
  },
  computed: {
    ...mapGetters('AuthModule', [
      'getUserSubscription',
      'getTeam',
      'getTeamSubscriptionState'
    ]),
    showDevButton () {
      return !window.location.origin.includes('foreplay.co')
    },
    getCountdownTime () {
      return this.countdownTime ? this.countdownTime : '0:00'
    },
    getProducts () {
      // Calculate the team member price
      let memberPrice

      const freeMembers = this.plan.name.includes('Full Workflow') ? 2 : 1
      const billableMembers = this.teamMembers - freeMembers < 0 ? 0 : this.teamMembers - freeMembers

      if (this.paymentSchedule.includes('Annual')) {
        memberPrice = 18 * billableMembers * 12
      } else {
        memberPrice = 20 * billableMembers
      }

      const amount = this.spyderPackage[0].quantity
      let priceId = this.spyderPackage[0].id
      let price = this.spyderPackage[0].value

      if (this.spyderPackage[0].quantity > 2 && this.paymentSchedule.includes('Annual')) {
        priceId = this.spyderPackage[0].annualId
        price = this.spyderPackage[0].annualValue
      }

      const products = []

      if (billableMembers) {
        products.push({ name: 'Team Members', amount: this.teamMembers, price: memberPrice })
      }

      if (amount) {
        products.push({ name: 'Spyder Brands', amount, priceId, price })
      }

      return products
    }
  },
  async created () {
    this.countdownTime = localStorage.getItem('countdownTime') || '10:00'

    this.countdownInterval = setInterval(() => {
      const time = this.countdownTime.split(':')
      let minutes = parseInt(time[0])
      let seconds = parseInt(time[1])

      if (minutes === 0 && seconds === 0) {
        clearInterval(this.countdownInterval)
        return
      }

      if (seconds === 0) {
        minutes--
        seconds = 59
      } else {
        seconds--
      }

      if (!seconds || seconds === 30) {
        localStorage.setItem('countdownTime', `${minutes}:${seconds.toString().padStart(2, '0')}`)
      }

      this.countdownTime = `${minutes}:${seconds.toString().padStart(2, '0')}`
    }, 1000)

    const user = firebase.auth().currentUser

    await this.setUserSubscription(user)
    await this.fetchSubscriptions()

    this.plan = this.subscriptions?.find((subscription) => this.getUserSubscription?.product?.name === subscription.name) || this.subscriptions[1]

    // Get the team members
    await this.fetchUserTeam()
    if (this.getTeam) {
      this.teamMembers = this.getTeam.members.length

      this.teamMemberData = await FirebaseAPI.Teams.getTeamMembers()
      this.teamEmails = this.teamMemberData.map((member) => member.email)
    }
  },
  beforeDestroy () {
    localStorage.setItem('countdownTime', this.countdownTime)
    clearInterval(this.countdownInterval)
  },
  methods: {
    ...mapActions('AuthModule', ['setUserSubscription', 'fetchUserTeam']),
    resetTimer () {
      this.countdownTime = '10:00'
      localStorage.removeItem('countdownTime')
    },
    wipeCountdownTimer () {
      this.countdownTime = '0:00'
      localStorage.setItem('countdownTime', '0:00')
      clearInterval(this.countdownInterval)
    },
    async fetchSubscriptions () {
      this.loadingSubscriptions = true

      try {
        const db = firebase.firestore()

        const data = await db
          .collection('products')
          .where('active', '==', true)
          .get()

        for (let i = 0; i < data.docs.length; i++) {
          const currentDoc = data.docs[i].data()

          // REMOVE THIS WHEN TEAMS EXISTS
          // if (currentDoc.name === 'Full Workflow') {
          //   continue
          // }

          if (!currentDoc.metadata.perks) {
            continue
          }

          const subscription = {
            ...currentDoc,
            perks: JSON.parse(currentDoc.metadata.perks),
            price: [],
            order: currentDoc.metadata.order,
            description: currentDoc.metadata.description
          }

          const priceSnap = await data.docs[i].ref
            .collection('prices')
            .where('active', '==', true)
            .get()

          priceSnap.docs.forEach((doc, index) => {
            if (doc.data().interval === 'year') {
              subscription.annualPrice = {
                ...doc.data(),
                id: doc.id
              }
            }

            if (!index) {
              subscription.price = {
                ...doc.data(),
                id: doc.id
              }
            }
          })

          this.subscriptions = [...this.subscriptions].concat(subscription)
        }
      } catch (e) {
        console.log(e)
        this.$showAlert({
          message: e,
          type: 'error'
        })
      } finally {
        this.loadingSubscriptions = false
      }
    }
  }
}
</script>
